export const HeroIcon = () => {
  return (
    <>
      <svg width="56" height="57" viewBox="0 0 56 57" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect y="0.5" width="56" height="56" rx="28" fill="#FFECDD" />
        <rect x="22" y="29.5" width="4" height="4" rx="2" transform="rotate(90 22 29.5)" stroke="#FF7000" strokeWidth="2" />
        <rect x="33" y="28.5" width="4" height="4" rx="2" transform="rotate(-90 33 28.5)" stroke="#FF7000" strokeWidth="2" />
        <path
          d="M34 27.5L32.5 29C31.4829 30.0171 30.9744 30.5256 30.3628 30.6384C30.1229 30.6826 29.8771 30.6826 29.6372 30.6384C29.0256 30.5256 28.5171 30.0171 27.5 29V29C26.4829 27.9829 25.9744 27.4744 25.3628 27.3616C25.1229 27.3174 24.8771 27.3174 24.6372 27.3616C24.0256 27.4744 23.5171 27.9829 22.5 29L21 30.5"
          stroke="#FF7000"
          strokeWidth="2"
        />
      </svg>
    </>
  );
};
